import { API_ROUTE_CONTROLLER, API_VERBS } from "./route";
import { BaseService } from "./base";
import Cookies from 'universal-cookie';
import { API_HOST } from "../config";

const cookies = new Cookies();

export class AutoService extends BaseService {
  site_id = "";
  company_id = "";
  getWorkingHours = async (site_id, company_id, user_ext, roleId) => {
    this.site_id = site_id;
    this.company_id = company_id;
    console.log("Getting", roleId);
    if (roleId == 1) {
      console.log("jshdfsdjfjdf")
      return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmyaccwebgetcompanyworkinghours, { site_id: site_id, Company_Id: company_id, Type: 2, Extension: "200" }));
    } else {
      console.log("aaaaaaaaaaaaaaaaaaaaa")
      return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmyaccwebgetcompanyworkinghours, { site_id: site_id, Company_Id: company_id, Type: 2, Extension: user_ext }));
    }



  };
  getWorkingHours_ProfileSettings = async (site_id, company_id, ext) => {
    this.site_id = site_id;
    this.company_id = company_id;
    this.user_ext = ext;
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmyaccwebgetcompanyworkinghours, { site_id: site_id, Company_Id: company_id }));
  };
  setWorkingHours_ProfileSettings = async (site_id, company_id, ext) => {
    this.site_id = site_id;
    this.company_id = company_id;
    this.user_ext = ext;
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmyaccwebgetcompanyworkinghours, { site_id: site_id, Company_Id: company_id }));
  };

  setWorkingHours = async (type = "24 hours/7 days a week", hours = "", user_ext) => {
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmyaccwebinsertcompanyworkinghours, { site_id: this.site_id, Company_Id: this.company_id, Extension_Number: user_ext, Type: 2, Working_Business_Type: type, Working_Hours: hours }));
  };

  setHolidayHours = async (body) => {
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmyaccountholidayannouncementcreate, body));
  };
  setHolidayHours_ProfileSettings = async (body, user_ext) => {
    this.user_ext = user_ext;
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmyaccountholidayannouncementcreate, body));
  };

  getHolidayHours = async () => {
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmyaccountholidayannouncementgetdetails, { Company_Id: this.company_id, announcement_id: 0 }));
  };
  getHolidayHours_ProfileSettings = async (user_ext) => {
    this.user_ext = user_ext;
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmyaccountholidayannouncementgetdetails, { Company_Id: this.company_id, announcement_id: 0 }));
  };

  getOrderExtension = async (OrderId) => {
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmyaccwebuserorderextension, { OrderId: OrderId, Order_Type: 2 }));
  };

  getVoiceMailSettings = async (domainId, ext) => {
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urextnvoicemailgetsetting, { domain_id: domainId, extension: ext }));
  };

  getVoiceMailUpdate = async (domainId, ext, pwd_status) => {
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urextnvoicemailgetsetting, { domain_id: domainId, extension: ext, pwd_status: pwd_status, voicemail_pwd: "", voicemail_status: "" }));
  };

  savePinVoicemailStatuss = async (domainId, ext, pin) => {
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urextnvoicemailinsertsetting, { domain_id: domainId, extension: ext, pwd_status: 0, voicemail_pwd: pin, voicemail_status: 0 }));
  };

  pin_setting = async (domainId, ext, pin, passtatus) => {
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urextnvoicemailinsertsetting, { domain_id: domainId, extension: ext, pwd_status: passtatus, voicemail_pwd: pin, voicemail_status: passtatus }));
  };

  pin_setting_status = async (domainId, ext, pin, passtatus) => {
    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urextnvoicemailinsertsetting, { domain_id: domainId, extension: ext, pwd_status: 0, voicemail_pwd: "", voicemail_status: 0 }));
  };

  getUserExtension = async (url, body) => {
    return await this.getResponse(await this.post(url, body));
  };

  setRgionalSettings = async (timezone, time_format) => {
    let body = {
      "site_id": this.site_id,
      "Company_Id": this.company_id,
      "Time_zone": timezone,
      "Home_country_code": "United Kingdom (44)",
      "Greetings_language": 1,
      "User_language": 1,
      "Regional_format": "English (UK)",
      "Time_format": 12
    };

    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmyaccwebupdatecompanyregionalsetting, body));
  };

  getRgionalSettings = async () => {
    let body = {
      "site_id": this.site_id,
      "Company_Id": this.company_id,
      "extension": ""
    };

    return await this.getResponse(await this.post(API_ROUTE_CONTROLLER.Urmyaccwebgetcompanyregionalsettingdtl, body));
  };

  setUpdateTranscriptSettings = async (body) => {
    return await this.getResponse(await this.patch(API_ROUTE_CONTROLLER.updateTranscriptSettings, body));
  };

  getTranscriptSettings = async () => {
    return await this.getResponse(await this.get(API_ROUTE_CONTROLLER.getTranscriptSettings + "/" + this.company_id));
  };

}

